import { Api } from './Api';

export function* getAllReviews(){
    const jsonData = yield Api.get("/review");
    return jsonData;
}